import { useGetFrontTipiDomandaId } from '@framework/api-client/api/inquiries-compile/tipi-domanda/tipi-domanda.ts';
import { useAuth } from '@framework/auth/state/AuthSlice.tsx';
import { selectTranslatedInquiryType } from '@framework/common-web/schema/translations/selectTranslatedInquiryType.ts';
import { CoverParagraphs } from '@framework/common-web/ui/inquiry/cover/CoverParagraphs.tsx';
import { TitleSubmissionRow } from '@framework/common-web/ui/inquiry/submission/TitleSubmissionRow.tsx';
import { FlexSubmissionRow } from '@framework/frontoffice-submission/submission/FlexSubmissionRow.tsx';
import { ResponsiveCard } from '@framework/ui/components/card/ResponsiveCard.tsx';
import { useBreadcrumbItem } from '@framework/ui/core/router/breadcrumbs/BreadcrumbContext.tsx';
import { type BrandedPath } from '@framework/ui/core/router/TypedRoute.tsx';
import { useTranslation } from 'react-i18next';
import { type RouteComponentProps } from 'react-router';
import { useTheme } from 'styled-components';
import { PageLayout } from '../../../ui/layout/PageLayout.tsx';
import { NetworkAlertPage } from '../../errors/network-alert/NetworkAlertPage.tsx';
import { LoadingPage } from '../../loading/LoadingPage.tsx';
import { CoverImage } from './component/CoverImage.tsx';
import { InquiryItem } from './inquiry/InquiryItem.tsx';

interface Params {
  id: string;
}

export interface IInquiryCoverPageProps extends RouteComponentProps<Params> {}

export function InquiryCoverPage(props: IInquiryCoverPageProps) {
  const inquiryId = props.match.params.id;

  const { isLogged } = useAuth();
  const { t } = useTranslation();
  const theme = useTheme();

  const { data, error, isLoading } = useGetFrontTipiDomandaId(inquiryId, {
    query: { keepPreviousData: true, select: selectTranslatedInquiryType },
  });

  useBreadcrumbItem({
    path: isLogged ? '/domande' : '/',
    title: t('inquiry.lista.briciole.domande', 'Domande'),
  });
  useBreadcrumbItem({
    path: props.location.pathname as BrandedPath,
    title: data?.titolo ?? t('inquiry.lista.briciole.domanda', 'Domanda'),
  });

  if (isLoading) return <LoadingPage />;

  if (error) {
    return (
      <NetworkAlertPage
        message={t(
          'inquiry-cover.errore-caricamento-copertina-domanda',
          'Impossibile caricare la copertina della domanda',
        )}
        error={error}
      />
    );
  }
  const cover = data?.copertina;
  if (!cover) {
    return (
      <NetworkAlertPage
        message={t(
          'inquiry-cover.errore-caricamento-copertina-domanda',
          'Impossibile caricare la copertina della domanda',
        )}
        error={new Error('No cover data found')}
      />
    );
  }

  return (
    <PageLayout>
      <ResponsiveCard
        hideCardHeader={theme.searchButtonOnTableFlag}
        title={
          <TitleSubmissionRow>
            {cover.titolo ??
              data.titolo ??
              t('inquiry-cover.titolo-non-presente', 'Titolo non presente')}
          </TitleSubmissionRow>
        }
      >
        <FlexSubmissionRow
          menu={<InquiryItem inquiry={data} />}
          menuSide="right"
        >
          <CoverImage cover={cover} />
          <CoverParagraphs paragraphs={cover.paragrafi} />
        </FlexSubmissionRow>
      </ResponsiveCard>
    </PageLayout>
  );
}
